const DefaultRegionCode = () => {
  const url = window.location.href
  if (url.includes('annatel.net')){
    return "IL"
  }

  if (url.includes('annatel.us') || url.includes('en_US')  ){
    return "US"
  }

  return "IL"
}
export default DefaultRegionCode;



// WEBPACK FOOTER //
// ./src/localeAssets/DefaultRegionCode.js